export const PIN_ITEM = 'PIN_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'


/** WEBPACK FOOTER **
 ** ./constants/ActionTypes.js
 **/